import React from 'react';
import { X } from 'lucide-react';

function ContactPopup({ isOpen, onClose }) {
  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    // Logic to send data to your API_URL
    alert("Thank you! Your message has been sent successfully.");
    onClose();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10002, // Ensure it stays above other elements
      padding: '20px'
    }} onClick={onClose}>
      <div style={{
        background: 'white',
        width: '100%',
        maxWidth: '480px',
        borderRadius: '24px',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 20px 50px rgba(0,0,0,0.3)'
      }} onClick={(e) => e.stopPropagation()}>
        
        {/* Header with GUDY Brand Style */}
        <div style={{
          background: 'linear-gradient(135deg, #6B4423 0%, #8B5A3C 100%)', // Matches GUDY theme
          padding: '28px',
          color: 'white',
          position: 'relative'
        }}>
          <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '700' }}>Contact Us</h2>
          <p style={{ margin: '8px 0 0', opacity: 0.9, fontSize: '14px' }}>How can we help you today?</p>
          <button onClick={onClose} style={{ 
            position: 'absolute', top: '24px', right: '24px', 
            background: 'none', border: 'none', color: 'white', cursor: 'pointer' 
          }}>
            <X size={24} />
          </button>
        </div>

        {/* Form Body */}
        <form onSubmit={handleSubmit} style={{ padding: '30px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#6B4423' }}>Full Name</label>
            <input required type="text" name="name" autoComplete="name" placeholder="Enter your name" style={{ width: '100%', padding: '12px 16px', borderRadius: '12px', border: '2px solid #F5EAD8', outline: 'none' }} />
          </div>
          
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#6B4423' }}>Email Address</label>
            <input required type="email" name="email" autoComplete="email" placeholder="example@email.com" style={{ width: '100%', padding: '12px 16px', borderRadius: '12px', border: '2px solid #F5EAD8', outline: 'none' }} />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#6B4423' }}>Message</label>
            <textarea required name="message" autoComplete="off" rows="4" placeholder="Type your message here..." style={{ width: '100%', padding: '12px 16px', borderRadius: '12px', border: '2px solid #F5EAD8', outline: 'none', resize: 'none' }}></textarea>
          </div>

          <button type="submit" style={{
            background: '#6B4423',
            color: 'white',
            border: 'none',
            padding: '16px',
            borderRadius: '12px',
            fontWeight: '700',
            fontSize: '16px',
            cursor: 'pointer',
            transition: 'transform 0.2s',
            boxShadow: '0 4px 12px rgba(107,68,35,0.2)'
          }}>
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
}

export default ContactPopup;